import { render } from "./DateCell.vue?vue&type=template&id=4f132452&scoped=true"
import script from "./DateCell.vue?vue&type=script&lang=js"
export * from "./DateCell.vue?vue&type=script&lang=js"

import "./DateCell.vue?vue&type=style&index=0&id=4f132452&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f132452"]])

export default __exports__